import { useModel } from '../../../lib/state'
import dbEntityModelFactory from '../entityModelFactory'
import initEntityModel from './initEntityModel'
import ContentComps from './ContentComps'
import { queryData_fields } from '../../Query/util'
import { mapValues } from 'lodash'

import appusersEntityCfg from '../appusers'
import shoesEntityCfg from '../shoes'

let entityCfg = {
  ContentComps,
  dbEntityType: 'cohorts',
  label: 'Cohort',
  labelPlural: 'Cohorts',
  icon: 'fas fa-chart-pie',
  relations: {
    belongsTo: {
      organization: true,
      app: 'OPTIONAL',
      saasuser: true,
    },
    hasOne: {},
    hasMany: {},
  },
  actionsPermissionCfgs: {
    role: {
      anyAdmin: { edit: true, delete: true },
      anyRole:  { new: true, clone: true },
    },
    entity: {
      owner: { edit: true, delete: true },
    },
  },
  modalOpts: {
    base: {
      editor: {
        size: 'large',
      },
    },
  },
  manage: {
    tabsCfg: {
      // TODO_MAYBE organization level toggle
      '/appusers': {
        label: 'User',
        newEntityOpts: { target: 'appusers', type: 'withEvents' },
        filter: (item) => item.query.target === 'appusers' && item.query.type === 'withEvents',
      },
      '/shoes': {
        label: 'Shoe',
        newEntityOpts: { target: 'shoes' },
        filter: (item) => item.query.target === 'shoes' && !item.query.type
      },
      '/mine': {
        label: 'My Cohorts',
        onlyOwnedBySelf: true
      },
    }
  },
}

const allowedTargetEntities = {
  appusers: appusersEntityCfg,
  shoes: shoesEntityCfg,
}

entityCfg = {
  ...entityCfg,
  otherData: {
    targets: {
      ...mapValues(allowedTargetEntities, (entityCfg) => {
        return {
          label: entityCfg.label,
          labelPlural: entityCfg.labelPlural,
          icon: entityCfg.icon,
        }
      })
    },
    // types: {
    //   event: {
    //     label: '...performed Event'
    //   },
    //   property: {
    //     label: '...had Property'
    //   },
    //   new: {
    //     label: '...had been New'
    //   },
    //   active: {
    //     label: '...had been Active'
    //   }
    // }
  },
}

entityCfg = {
  ...entityCfg,
  getNewEntityBase(newEntityOpts = {}) {
    return {
      query: {
        target: newEntityOpts.target,
        type: newEntityOpts.type,
      },
    }
  },
  nameLabel: 'Title',
  nameDataPath: 'name',
  getEntityName(entity) {
    return entity.name
  },
  getManagerContentsAndTooltips_single(entity) {
    const fields = queryData_fields(entity.query).map((field) => {
      const split = field.split('.')
      return split[split.length - 1]
    }).join(', ')

    return [ fields, `Included fields: ${fields}` ]
  },
  getEntityLabelPrefix(entity) {
    const target = (entity.query && entity.query.target)
    return target && entityCfg.otherData.targets[target].label
  },
  getEntityLabelSuffix(entity) {
    return null
  },
}

const entityModel =  dbEntityModelFactory(initEntityModel(entityCfg))
const useEntityModel = (stateInitializerArgs) => useModel(entityModel, stateInitializerArgs)
entityCfg.useEntityModel = useEntityModel

export default entityCfg